import { useEffect, useRef } from "react";

import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectShowVersionMismatchWarning } from "store/selectors/local";
import { localStateActions } from "store/slices/local";
import { GENERAL_EVENT_CATEGORY, trackEvent } from "utils/amplitude";
import { clearCacheAndReload } from "utils/urls";

export const Banners = () => {
  const dispatch = useAppDispatch();
  const hasTrackedBannerRef = useRef<boolean>(false);
  const showVersionMismatchWarning = useAppSelector(selectShowVersionMismatchWarning);

  useEffect(() => {
    if (showVersionMismatchWarning && !hasTrackedBannerRef.current) {
      hasTrackedBannerRef.current = true;
      trackEvent("Outdated version banner displayed", GENERAL_EVENT_CATEGORY);
    }
  }, [showVersionMismatchWarning]);

  if (showVersionMismatchWarning) {
    return (
      <Banner
        actionButtonText={t("warning.version_mismatch.refresh_button")}
        closeEventName="Outdated version banner - Dismiss"
        eventName="Outdated version banner - Refresh now"
        kind="warning"
        onAction={clearCacheAndReload}
        onDismiss={() => dispatch(localStateActions.setShowVersionMismatchWarning(false))}
      >
        {t("warning.version_mismatch.message")}
      </Banner>
    );
  }

  return null;
};
